module.exports =
  ENV: 'test'
  baseApiUrl: 'http://localhost:3000'
